import React from "react";
import { assignSupplierName } from "../../../../utils/tch";
import { FaArrowUp } from "react-icons/fa";
import { Tooltip } from "antd";

const cheapestStyle = { fontWeight: "bold", fontSize: "1.1em", backgroundColor: "#d4edda", padding: "2px 6px", borderRadius: "4px" };

function ResiduesItem({ item, isCheapest }) {
  return (
    <tr style={{ borderBottom: "1px solid #DBDBDB" }}>
      <td className="residuesItem">
        <div className="d-flex">
          {item.quantity}{" "}
          {(item.balance_without_order_invoices || item.balance_without_order_invoices === 0) && (
            <span className="text-danger ml-1">
              ({item.balance_without_order_invoices})
            </span>
          )}
        </div>
      </td>
      <td>
        {item?.supplying_incomes?.map((income, index) => (
          <div key={index} className="d-flex flex-column residuesItem">
            <Tooltip placement="top" title="Arriving quantity & date">
              <div className="text-success d-flex align-items-center">
                {income?.quantity} <FaArrowUp size={6} />
              </div>
              <div className="no-wrap">{income.arriving_at}</div>
            </Tooltip>
          </div>
        ))}
      </td>
      <td className="residuesItem">
        <span style={isCheapest ? cheapestStyle : {}}>{item.originalCode}</span>
      </td>
      <td className="residuesItem">{item.originalTitle}</td>
      <td className="residuesItem">{item.code}</td>
      <td className="residuesItem">
        {assignSupplierName(item.supplier?.name)}
      </td>
      <td className="residuesItem">
        <span style={isCheapest ? cheapestStyle : {}}>
          {!!item.wholesale_price ? item.wholesale_price : ""}
        </span>
      </td>
    </tr>
  );
}

export default ResiduesItem;
